import apiHub from "../services/apiHub";

export default class SsoRepository {
	consumeRedirectHash = (hash) => {
		return apiHub.post("/api/oauth/user/redirect/consume", { hash });
	};
}
